var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "absolute text-blue-500 left-1/2 -top-3 -translate-x-1/2 transform rotate-90 h-full",
    width: "9px",
    height: "16px",
    viewBox: "0 0 9 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tooltips-",
    transform: "translate(-874.000000, -1029.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-16",
    transform: "translate(850.000000, 975.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(24.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    transform: "translate(4.500000, 62.000000) rotate(-90.000000) translate(-4.500000, -62.000000) ",
    points: "4.5 57.5 12.5 66.5 -3.5 66.5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.026a502f294a5d8800f7d0ac1113099e.svg";
export { ForwardRef as ReactComponent };